import { FileModel } from 'services/EpdClient';
import styled from 'styled-components';
import Spinner from 'styles/spinner-left.styled';
import FileRow from './FileRow';

type TProps = {
  files?: FileModel[];
  disabled?: boolean;
  onRemoveFile?(fileId: string): void;
  fileLoading?: boolean;
  className?: string;
};

const FilesList = ({ files, disabled, onRemoveFile, fileLoading, className }: TProps) => {
  return (
    <Wrapper>
      {fileLoading && (
        <SpinnerRow>
          <Spinner inline />
        </SpinnerRow>
      )}
      {files?.map((f) => (
        <FileRow
          key={f.id}
          file={f}
          disabled={disabled}
          onRemoveFile={onRemoveFile ? () => onRemoveFile(f.id!) : undefined}
          className={className}
        />
      ))}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: grid;
  gap: 8px;

  .compare-left-updated,
  .compare-left-removed {
    border: 1px solid ${(props) => props.theme.colors.statusLabelRedText};
  }

  .compare-right-updated,
  .compare-right-added {
    border: 1px solid ${(props) => props.theme.colors.primaryGreen};
  }
`;

const SpinnerRow = styled.div`
  flex-direction: row;
  padding: 14px 16px;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;

  ${Spinner} {
    width: 1rem;
    height: 1rem;
  }
`;

export default FilesList;
